/*
 * @Description:
 * @Date: 2022-06-30 17:10:30
 */

import { withdrawals } from '@/api/ajax';
import { twoDecimal } from '@/tools/money';
export default {
  data() {
    return {
      outFee_mixin: 0 // 提现手续费
    };
  },
  async created() {
    const { pdata } = await withdrawals.getAccountOutFee();
    this.outFee_mixin = +twoDecimal(pdata, 100);
  }
};
